import { SubmitManualAdvancePaymentResult } from '@varo/graphql-schema-types';
import { isSubmitManualAdvancePaymentError } from 'features/advance/helpers/Advance.helpers';
import { useTranslation } from 'react-i18next';
import ManualAdvancePayment from 'services/graphql/mutations/Advance/ManualAdvancePayment';
import useCancellableMutation from 'shared/hooks/useCancellableMutation';

interface AdvanceRepayment {
  submitManualAdvancePayment: SubmitManualAdvancePaymentResult;
}

const useConfirmAdvanceRepayment = () => {
  const { t } = useTranslation('advance', {
    keyPrefix: 'advanceConfirmPaymentStrings',
  });
  const [{ data, fetching, error: manualPaymentError }, executeMutation] =
    useCancellableMutation<AdvanceRepayment>(ManualAdvancePayment);

  const paymentResult = data?.submitManualAdvancePayment;

  const paymentError = isSubmitManualAdvancePaymentError(paymentResult)
    ? paymentResult
    : undefined;

  const error =
    paymentError || manualPaymentError
      ? {
          title: paymentError ? paymentError.title : t('errorTitle'),
          message: paymentError ? paymentError.message : t('errorBody'),
          action: paymentError?.action,
        }
      : null;

  return {
    data,
    fetching,
    error,
    executeConfirmRepaymentMutation: executeMutation,
  };
};

export default useConfirmAdvanceRepayment;
